import {forwardRef} from 'react';
import {CloseIcon} from '@/components/Icons';
import {getGlobalButtons} from '@/services/content/appContent';
import {twx} from '@/utils/tailwindUtils';

type CloseButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
    icon?: React.ReactNode;
    alt?: string;
};

const CloseButton = forwardRef<HTMLButtonElement, CloseButtonProps>(({className, icon, alt, ...restProps}, ref) => (
    <button
        type='button'
        ref={ref}
        data-testid='close-button'
        className={twx(
            'flex h-11 w-11 items-center justify-center rounded-full border-0 bg-transparent p-0 outline-none',
            className
        )}
        aria-label={alt ?? getGlobalButtons().closeButton?.alt ?? undefined}
        {...restProps}
    >
        {icon ?? <CloseIcon />}
    </button>
));

CloseButton.displayName = 'CloseButton';

export default CloseButton;
